export default "__VITE_ASSET__B19tz5Us__"